export const filterOutEventsFromSetMap: (
    events: Map<string, Set<string>>,
    agEventGeneralGuidsToFilter: string[]
) => Map<string, Set<string>> = (events, agEventGeneralGuidsToFilter) =>
    [...events.entries()].reduce((accumulator, item) => {
        const [fieldGuid, selectedEventGuidSet] = item;
        const filteredEventGuids = new Set(
            [...selectedEventGuidSet.values()].filter(
                (eventGuid) => !agEventGeneralGuidsToFilter.includes(eventGuid)
            )
        );
        accumulator.set(fieldGuid, filteredEventGuids);
        return accumulator;
    }, new Map<string, Set<string>>());

export const filterOutEventsFromSet: (
    events: Set<string>,
    agEventGeneralGuidsToFilter: string[]
) => Set<string> = (events, agEventGeneralGuidsToFilter) =>
    new Set(
        [...events.values()].filter((eventGuid) => !agEventGeneralGuidsToFilter.includes(eventGuid))
    );
